export default __webpack_public_path__ + "e98ed894e2b6ec15ea239442f35e10cf.webp";